var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64172 6.26595C8.64172 7.22895 7.86072 8.00995 6.89772 8.00995C5.93472 8.00995 5.15472 7.22895 5.15472 6.26595C5.15472 5.30295 5.93472 4.52295 6.89772 4.52295C7.86072 4.52295 8.64172 5.30295 8.64172 6.26595Z",
    stroke: "#93AFB9",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.652 6.26572C12.652 8.74372 9.15404 13.1627 7.61304 14.9897C7.23804 15.4337 6.55804 15.4337 6.18304 14.9897C4.64204 13.1627 1.14404 8.74372 1.14404 6.26572C1.14404 3.08772 3.72004 0.511719 6.89804 0.511719C10.076 0.511719 12.652 3.08772 12.652 6.26572Z",
    stroke: "#93AFB9",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.dbeaee93a1767b253d33e957a46dd791.svg";
export { ForwardRef as ReactComponent };